import { lazy } from "react";
import ReactDOM from "react-dom/client";
import {
  PublicClientApplication,
  EventType,
  AccountInfo,
  AuthenticationResult,
} from "@azure/msal-browser";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { Provider } from "react-redux";
import store from "./store/store";
import axios from "axios";

import global_en from "./translations/en/global.json";
import global_fr from "./translations/fr/global.json";
// import global_gr from "./translations/gr/global.json";
import auth_en from "./translations/en/authTranslation.json";
import auth_fr from "./translations/fr/authTranslation.json";
//import auth_gr from "./translations/gr/authTranslation.json";
import profile_en from "./translations/en/profileTranslation.json";
import profile_fr from "./translations/fr/profileTranslation.json";
//import profile_gr from "./translations/gr/profileTranslation.json";
import committee_en from "./translations/en/committeeTranslation.json";
import committee_fr from "./translations/fr/committeeTranslation.json";
//import committee_gr from "./translations/gr/committeeTranslation.json";
import member_en from "./translations/en/memberTranslation.json";
import member_fr from "./translations/fr/memberTranslation.json";
//import member_gr from "./translations/gr/memberTranslation.json";
import record_en from "./translations/en/recordTranslation.json";
import record_fr from "./translations/fr/recordTranslation.json";
//import record_gr from "./translations/gr/recordTranslation.json";
import ballot_en from "./translations/en/ballotTranslation.json";
import ballot_fr from "./translations/fr/ballotTranslation.json";
//import ballot_gr from "./translations/gr/ballotTranslation.json";
import configuration_en from "./translations/en/configurationTranslation.json";
import configuration_fr from "./translations/fr/configurationTranslation.json";
//import configuration_gr from "./translations/gr/configurationTranslation.json";
import report_en from "./translations/en/reportTranslation.json";
import report_fr from "./translations/fr/reportTranslation.json";
//import report_gr from "./translations/gr/reportTranslation.json";
import request_en from "./translations/en/requestTranslation.json";
import request_fr from "./translations/fr/requestTranslation.json";
//import request_gr from "./translations/gr/requestTranslation.json";
import standard_en from "./translations/en/standardTranslation.json";
import standard_fr from "./translations/fr/standardTranslation.json";
//import standard_gr from "./translations/gr/standardTranslation.json";
import {
  convertStringtoJson,
  decryptedInfo,
  setObjIntoWindow,
} from "./utils/storage";
import { ProgressSpinner } from "primereact/progressspinner";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Initialize i18next
i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    en: {
      global: global_en,
      auth: auth_en,
      profile: profile_en,
      committee: committee_en,
      member: member_en,
      record: record_en,
      ballot: ballot_en,
      configuration: configuration_en,
      report: report_en,
      request: request_en,
      standard: standard_en,
    },
    fr: {
      global: global_fr,
      auth: auth_fr,
      profile: profile_fr,
      committee: committee_fr,
      member: member_fr,
      record: record_fr,
      ballot: ballot_fr,
      configuration: configuration_fr,
      report: report_fr,
      request: request_fr,
      standard: standard_fr,
    },
    // gr: {
    //   global: global_gr,
    //   auth: auth_gr,
    //   profile: profile_gr,
    //   committee: committee_gr,
    //   member: member_gr,
    //   record: record_gr,
    //   ballot: ballot_gr,
    //   configuration: configuration_gr,
    //   report: report_gr,
    //   request: request_gr,
    //   standard: standard_gr,
    // },
  },
});

export let msalInstance: PublicClientApplication;

const initializeLoader = () => {
  return (
    <>
      <div className="loading-overlay-index-page visible">
        <div className="overlay-content-index-page ">
          <div className="auth-loader">
            <ProgressSpinner aria-label="Loading" />
            <p>
              This may take a few moments. If it takes too long, feel free to
              refresh the page.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to fetch and set MSAL configuration from the endpoint
const fetchConfigAndInitializeMsal = async () => {
  try {
    root.render(<>{initializeLoader()}</>);
    const response = await axios.get("/env-config.js?t=" + new Date().getTime(),);
    const json = response.data?.replace("window.env =", "");
    const configData = convertStringtoJson(json);
    setObjIntoWindow(configData);

  const msalConfig = {
      auth: {
        clientId: decryptedInfo(configData.REACT_APP_B2C_CLIENT_ID),
        authority: decryptedInfo(configData.REACT_APP_B2C_SIGNIN_AUTHORITY_URL),
         knownAuthorities: [
          decryptedInfo(configData.REACT_APP_B2C_AUTHORITY_DOMAIN),
        ],
        // redirectUri: "http://localhost:4200/signin-oidc",
        redirectUri: decryptedInfo(configData.REACT_APP_B2C_REDIRECT_URL),
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };

    msalInstance = new PublicClientApplication(msalConfig);

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const authResult = event.payload as AuthenticationResult;
        localStorage.setItem("account", JSON.stringify(authResult.account));
        msalInstance.setActiveAccount(authResult.account as AccountInfo);
      }
    });

    await msalInstance.initialize();

    root.render(
      <I18nextProvider i18n={i18next}>
        <Provider store={store}>
          <App instance={msalInstance} />
        </Provider>
      </I18nextProvider>,
    );
  } catch (error: any) {
    console.error("MSAL init failed", error);

    if (
      error?.message?.includes("Network Error") &&
      !sessionStorage.getItem("reloaded")
    ) {
      sessionStorage.setItem("reloaded", "true");
      setTimeout(() => window.location.reload(), 3000);
    }
  }
};

fetchConfigAndInitializeMsal();
reportWebVitals();
